'use client'
import {ReactNode, useState, useRef, Suspense, useEffect} from 'react';
import { ANCHOR, BACKPACK, BlockchainInfos, PHANTOM, WCW } from '../lib/blockchainSession.ts';
import { getBackPackPayload, getPhantomPayload, getSignUrl, validateAnchor, validateWax, verifyPayload } from '../lib/walletcheck.ts';
import waxjs from '../lib/wallets/waxjs';


type validateWalletPage = {
    blockchaininfos:BlockchainInfos;
}



const ValidateWallet =(props: validateWalletPage):ReactNode =>{

    const blockchaininfos=props.blockchaininfos;

    const [wax, setWax] = useState<any>(null);

    if(blockchaininfos.validated)
        return (<i className="fa-solid fa-lock-open"></i>);

    let payload:verifyPayload | null = null;

    if(blockchaininfos.myAccount === null)return(<i className="fa-solid fa-lock-open">no account</i>)
    let noWebPhantom = false;
    let connectURL = '';
    let phantom = null;
    
    if ('phantom' in window) {
      phantom = window.phantom ? window.phantom: null;
    }

    if(phantom === null){
        noWebPhantom = true;
        connectURL = getSignUrl(props.blockchaininfos.sessID, props.blockchaininfos.phantomInfos, props.blockchaininfos.seed);
    }

    

    switch(blockchaininfos.logType){
        case WCW:return (<div>{wax == null ? 
            ((<button className='btn verify-wallet' onClick={async ()=> 
            {
                const w = new waxjs.WaxJS({ rpcEndpoint: blockchaininfos.endpoints[0], freeBandwidth: false });
                await w.login();
                setWax(w);
            }
            }>login wax cloud wallet</button>)): 
            (<button className='btn verify-wallet' onClick={async ()=> 
            {
                payload = await validateWax(wax, blockchaininfos.mainContract, blockchaininfos.myAccount, blockchaininfos.seed);
                console.log(payload)
                
                if(payload){
                    const res = await fetch('/api/verifyWallet?sig='+payload.sig+'&tx='+payload.tx);
                    const resp = await res.json();

                    if(resp.result === 'ok'){
                        window.location.href='/select-car'
                    }else{
                        console.log(resp.error)
                    }

                }

            }
            }>validate wax cloud wallet sessions</button>)}</div>);break;
        case ANCHOR:return (<button className='btn verify-wallet' onClick={async ()=> 
            {
                payload = await validateAnchor(blockchaininfos.endpoints[0],blockchaininfos.chainId, blockchaininfos.mainContract, blockchaininfos.myAccount,  blockchaininfos.seed);
                console.log(payload)

                if(payload){
                    const res = await fetch('/api/verifyWallet?sig='+payload.sig+'&tx='+payload.tx);
                    const resp = await res.json();

                    if(resp.result === 'ok'){
                        window.location.href='/select-car'
                    }else{
                        console.log(resp.error)
                    }

                }
            }
        }>validate anchor sessions</button>);break;
        case PHANTOM:return (
        
             noWebPhantom === true ?
                    (<link
                        id='phantom-wallet' 
                        className='btn-sm btn-primary login-btn' 
                        href={connectURL}>
                    <img title='phantom web' className='wallet-logo' src="assets/img/phantom-wallet-logo.png" alt='phantom'/>
                    </link>)
                    :
                    (
                    <button className='btn verify-wallet' onClick={async ()=> 
                        {
                            payload = await getPhantomPayload(blockchaininfos.seed);
                            console.log(payload)

                            if(payload){
                                const res = await fetch('/api/verifyWallet?sig='+payload.sig);
                                const resp = await res.json();

                                if(resp.result === 'ok'){
                                    window.location.href='/select-car'
                                }else{
                                    console.log(resp.error)
                                }

                            }

                        }}>validate phantom sessions</button>
                    )
                );
            break;
        case BACKPACK:return (<button className='btn verify-wallet' onClick={async ()=> 
            {
                payload = await getBackPackPayload(props. blockchaininfos.seed);
                console.log(payload)
                 if(payload){
                    const res = await fetch('/api/verifyWallet?sig='+payload.sig);
                    const resp = await res.json();

                    if(resp.result === 'ok'){
                        window.location.href='/select-car'
                    }else{
                        console.log(resp.error)
                    }

                }
            }}>validate backpack sessions</button>);break;
    }

    
};

export default ValidateWallet;